import { Badge } from '@/components/ui/badge';
import { ShieldCheck, ShieldAlert, ShieldX, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DocumentStatusBadgeProps {
  verifiedAt?: string | null;
  expiry?: string | null;
  label?: string;
}

export const DocumentStatusBadge = ({ verifiedAt, expiry, label }: DocumentStatusBadgeProps) => {
  const { t } = useTranslation();

  // Not verified
  if (!verifiedAt || !expiry) {
    return (
      <Badge className="bg-[#5A6B7A]/10 text-[#5A6B7A] border-[#5A6B7A]/20 font-['Funnel_Sans'] gap-1">
        <ShieldAlert size={12} />
        {label ? `${label} · ` : ''}{t('fleet.documentStatus.unverified')}
      </Badge>
    );
  }

  const expiryDate = new Date(expiry);
  const now = new Date();
  const days = Math.ceil((expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (days <= 0) {
    return (
      <Badge className="bg-[#FF7171]/10 text-[#FF7171] border-[#FF7171]/20 font-['Funnel_Sans'] gap-1">
        <ShieldX size={12} />
        {label ? `${label} · ` : ''}{t('fleet.documentStatus.expired')}
      </Badge>
    );
  }

  if (days <= 30) {
    return (
      <Badge className="bg-[#F2AC57]/10 text-[#F2AC57] border-[#F2AC57]/20 font-['Funnel_Sans'] gap-1">
        <Clock size={12} />
        {label ? `${label} · ` : ''}{t('fleet.documentStatus.expiringSoon')}
      </Badge>
    );
  }

  return (
    <Badge className="bg-[#14A38B]/10 text-[#14A38B] border-[#14A38B]/20 font-['Funnel_Sans'] gap-1">
      <ShieldCheck size={12} />
      {label ? `${label} · ` : ''}{t('fleet.documentStatus.verified')}
    </Badge>
  );
};
